import { AlertColor, SnackbarOrigin } from '@mui/material';

export type NotificationOptions = {
  autoHideDuration?: number;
  location?: SnackbarOrigin;
  severity?: AlertColor;
};

const success: NotificationOptions = {
  location: {
    horizontal: 'center',
    vertical: 'top',
  },
  severity: 'success',
};

const error: NotificationOptions = {
  location: {
    horizontal: 'center',
    vertical: 'top',
  },
  severity: 'error',
};

export const NotificationOptions = {
  success,
  error,
};
